module.exports = __webpack_public_path__ + "static/venta01-7567d3ac7705e0b8f31c6ad237f15900.jpg";